import { Button } from '@optools/components/ui/button';
import { Label } from '@optools/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { LitmusValidationSchema } from '@optools/services/operator-gateway/media-validation/types';

import { formatValidationProcessName } from '../utils/format-validation-process';

export interface ValidationSuiteSelectProps {
  loading: boolean;
  onRunValidation: () => void;
  onValueChange: (value: string) => void;
  options: LitmusValidationSchema[];
  value: string;
}
export function ValidationSuiteSelect({
  loading,
  onRunValidation,
  onValueChange,
  options,
  value,
}: ValidationSuiteSelectProps) {
  return (
    <div className="mb-4 flex items-end gap-4">
      <div className="w-full">
        <Label className="mb-4 block">Validation Suite</Label>
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger aria-label="validation suite" className="w-full">
            <SelectValue placeholder="Select a Validation" />
          </SelectTrigger>
          <SelectContent>
            {options.map((schema) => {
              return (
                <SelectItem key={schema.validationProcess} value={schema.validationProcess}>
                  {formatValidationProcessName(schema.validationProcess)}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>
      <Button disabled={loading || !value} onClick={onRunValidation}>
        Run Validation
      </Button>
    </div>
  );
}
